import React from 'react';
import _ from 'lodash';
import Axios from '@/axiosPool';

class Name extends React.Component {
  constructor(props) {
    super(props);

    _.map(['onChecking', 'onChange'], (fn) => {
      this[fn] = this[fn].bind(this);
    });

    this.inputRef = React.createRef();
  }

  shouldComponentUpdate(nextProps) {
    if (
      !_.isEqual(nextProps.name, this.props.name) &&
      nextProps.name === null
    ) {
      this.inputRef.current.value = null;
    }

    return true;
  }

  onChecking(e) {
    Axios.get('api/project/checkName', { name: e }).catch((response) => {
      if (response) {
        if (this.props.onInputChange) {
          this.props.onInputChange({ name: e, error: true });
        }
      }
    });
  }

  onChange(e) {
    if (this.props.onInputChange) {
      this.props.onInputChange({
        name: e,
        error: e.length > 100 ? true : false,
      });
    }

    this.onChecking(e);
  }

  render() {
    const { name = '' } = this.props;
    const len = name ? name.length : 0;
    const debounced = _.debounce((value) => this.onChange(value), 400);

    return (
      <div class="formSection">
        <div class="formContainer">
          <label>
            Account Name <sup>*</sup>
          </label>
          <input
            ref={this.inputRef}
            type="text"
            placeholder="Add Text Here"
            class={`${this.props.error ? 'hasError' : ''}`}
            onChange={(e) => debounced(e.target.value)}
          />

          {len > 100 && (
            <span class="errorMsg" style={{ right: '-52%' }}>
              Must not exceed 100 characters
            </span>
          )}
          {this.props.error && len < 100 && (
            <span class="errorMsg">Account Name already exists!</span>
          )}
        </div>
      </div>
    );
  }
}

export default Name;
